import axios from "axios";

// STATE
const state = {
    balance: 0,
    codes: [],
};

// GETTERS
const getters = {};

// ACTIONS
const actions = {
    update({commit}) {
        return new Promise((resolve, reject) => {
            axios.get('/redemption/codes').then(response => {
                commit("setBalance", response.data.balance);
                commit("setCodes", response.data.codes);
                resolve(response.data);
            }, error => {
                reject(error.response);
            });
        });
    },
    add({commit}, code) {
        return new Promise((resolve, reject) => {
            axios.post('/redemption/add-code', { code: code }).then(response => {
                commit("setBalance", response.data.balance);
                commit("setCodes", response.data.codes);
                resolve(response.data);
            }, error => {
                reject(error.response);
            });
        });
    },
};

// MUTATIONS
const mutations = {
    setBalance(state, balance) {
        state.balance = balance;
    },
    setCodes(state, codes) {
        state.codes = codes;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
